import { MapCalloutObject } from '@ng-cloud/badger-core/map/objects/map-callout-object';
import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { MapGrouping } from './map-grouping';
import { MapLayer } from './map-layer';

export class MapCalloutGrouping extends MapGrouping<Point, MapCalloutObject> {

  constructor(public options: any = {}, public layerName: string = 'map_callout', public zIndex: number = 100) {
    super(options);

    this.layers = [new MapLayer(Object.assign({}, { name: layerName, zIndex: zIndex }, { grouping: this }))];
  }

  setOptions(options: any = []) {
    this.options = Object.assign(this.options, options);
  }

  createObject(data: Point): MapCalloutObject {
    const points: Point[] = [data];

    return new MapCalloutObject(data, points, Object.assign({ radius: this.storeMap.mToPx(2) }, this.options));
  }
}
